<template>
  <div class="shopInfo">
    <h4>{{ shopInfo.name || '--' }}</h4>
    <div class="shopInfo_center">
      <div class="shopImg">
        <el-image :src="`${shopInfo.logo}`" class="bg">
          <div slot="error" class="image-slot bg-font-size-m">
            <i class="el-icon-s-shop"></i>
          </div>
        </el-image>
      </div>
      <div :span="16" style="text-align: center;">
        <div class="shopInfo_center_text">商品评价 &nbsp;<i>{{ shopInfo.shopscore || 5.0 }}</i></div>
        <div class="shopInfo_center_text">服务态度 &nbsp;<i>{{ shopInfo.shopattitude || 5.0 }}</i></div>
        <div class="shopInfo_center_text">物流速度 &nbsp;<i>{{ shopInfo.shopspeed || 5.0 }}</i></div>
      </div>
    </div>
    <el-divider></el-divider>
    <div class="twoButtom" v-if="isshow==1">
      <router-link :to='`/shopStore?storeId=${shopInfo.bxmId}`'>进店逛逛</router-link>
      <a v-if="shopInfo.isCollect === 1" @click="toggleCollect"><i class="el-icon-star-on"></i>已关注</a>
      <a v-else @click="toggleCollect"><i class="el-icon-star-off"></i> 关注店铺</a>
    </div>
  </div>
</template>
<script>
import {addCollection, removeCollection} from "@/api/xunyou";

export default {
  name: 'shopStoreItem',
  data() {
    return {};
  },
  props: ['isshow', 'shopInfo'],
  computed: {
    userId () {
      return this.$store.getters.userId;
    }
  },
  methods: {
    // 切换收藏状态
    toggleCollect() {
      this.$tools.isLogin(() => {
        const params = {
          type: 2, // 1:商品；2：店铺；必填
          uid: this.userId,
          cid: this.shopInfo.bxmId
        }
        let promise = null;
        if (this.shopInfo.isCollect === 1) {
          this.shopInfo.isCollect = 0;
          promise = removeCollection(params);
        } else {
          this.shopInfo.isCollect = 1;
          promise = addCollection(params);
        }
        promise.then(res => {
          console.log('收藏结果：', res);
        }).catch(err => {
          this.$message.error("操作失败，请稍后再试！");
        });
      });
    }
  }
};
</script>

<style scoped lang='less'>

.shopInfo {
  box-sizing: border-box;
  font-size: 14px;
  margin-bottom: 10px;
  background-color: #fff;
}
.shopInfo h4 {
  padding: 10px;
  border-bottom: 1px solid #ddd;
  font: 700 14px "microsoft yahei";
  overflow: hidden;
  background-color: #dddddd;
}

.shopInfo_center {
  padding: 10px;
  box-sizing: border-box;
  font-size: 12px;
  display: flex;
  justify-content: space-around;
}

.shopImg {
  width: 65px;
}

.shopInfo_center_text {
  line-height: 20px;
  color: #999;
}

.el-divider--horizontal {
  margin: 0;
}

.twoButtom {
  font-size: 12px;
  display: flex;
  justify-content: space-around;
  padding: 10px 5px;
  box-sizing: border-box;

  /deep/ i.el-icon-star-on {
    color: #f12b2d;
    vertical-align: middle;
  }

  /deep/ i.el-icon-star-off {
    vertical-align: middle;
  }
}

.twoButtom a {
  background: #dddddd;
  border: 1px solid #c0c0c0;
  width: 40%;
  text-align: center;
  padding: 5px 0px;
  box-sizing: border-box;
  cursor: pointer;
}
</style>







// WEBPACK FOOTER //
// src/components/shopStoreItem.vue